var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          id: "loader",
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-left product-listing",
          on: {
            click: function ($event) {
              _vm.setActiveProduct()
              _vm.viewProduct(_vm.productKey)
            },
          },
        },
        [
          _c("img", { attrs: { src: _vm.productInfo.image } }),
          _vm._v(" "),
          _c("h3", { staticClass: "product-name" }, [
            _vm._v(_vm._s(_vm.productInfo.name)),
          ]),
          _vm._v(" "),
          !_vm.hidePriceListingForVG &&
          _vm.shouldCustomerSeePricing &&
          (!_vm.isENT ||
            (_vm.defaultOffer && _vm.defaultOffer.monthlyUnitPrice) ||
            _vm.productKey.includes("CBL"))
            ? [
                [
                  _vm.calculatedSalesPrice !== _vm.calculatedListPrice
                    ? [
                        _c(
                          "span",
                          {
                            class:
                              _vm.smallFleetOpportunity &&
                              _vm.isAccountCreatedAfterTitan
                                ? "small-fleet-list-price"
                                : "default-offer-list-price",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.currencySymbol.toUpperCase()) +
                                _vm._s(
                                  _vm.calculatedListPrice.toLocaleString(
                                    "en-US"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            class:
                              _vm.smallFleetOpportunity &&
                              _vm.isAccountCreatedAfterTitan
                                ? "small-fleet-sale-price"
                                : "default-offer-sales-price",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.currencySymbol.toUpperCase()) +
                                _vm._s(
                                  _vm.calculatedSalesPrice.toLocaleString(
                                    "en-US"
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyIsoCode) +
                                _vm._s(
                                  _vm.paymentTerm ? `/${_vm.paymentTerm}` : ""
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "span",
                          {
                            class:
                              _vm.smallFleetOpportunity &&
                              _vm.isAccountCreatedAfterTitan
                                ? "small-fleet-sale-price"
                                : "default-offer-sales-price",
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.currencySymbol.toUpperCase()) +
                                _vm._s(
                                  _vm.calculatedSalesPrice.toLocaleString(
                                    "en-US"
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyIsoCode) +
                                _vm._s(
                                  _vm.paymentTerm ? `/${_vm.paymentTerm}` : ""
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.smallFleetOpportunity &&
                  _vm.defaultOffer.offerKey.toLowerCase().includes("license")
                    ? _c("span", { staticClass: "small-fleet-payment-terms" }, [
                        _vm._v("due at checkout for 3 year license"),
                      ])
                    : _vm._e(),
                ],
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("p", { staticClass: "product-brief" }, [
            _vm._v(_vm._s(_vm.productInfo.brief)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex justify-center md:justify-start mt-1/2 items-center",
            },
            [
              _vm.showProductDetails
                ? _c(
                    "a",
                    {
                      staticClass: "view-product",
                      on: {
                        click: function ($event) {
                          _vm.setActiveProduct(false)
                          _vm.viewProduct(_vm.productKey)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.webstoreContent.viewProduct) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hidePriceListingForVG &&
              _vm.shouldCustomerSeePricing &&
              (!_vm.isENT ||
                (_vm.defaultOffer && _vm.defaultOffer.monthlyUnitPrice) ||
                _vm.productKey.includes("CBL"))
                ? _c(
                    "span",
                    {
                      staticClass: "buy-product",
                      on: { click: _vm.handleBuyButtonClick },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.webstoreContent.webstoreBody.product_nav.buy
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "buy-product",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleInquireButtonClick.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.webstoreContent.webstoreBody.product_nav.inquire
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }